import type { ValueHandler } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
import { handleSignature } from '@/value-handlers/signature'
import { handlePersonsAddress } from '@/value-handlers/persons-address'

export const VALUE_HANDLERS: Record<string, ValueHandler> = {
	'signature': handleSignature,
	'persons-address': handlePersonsAddress,
}